import React, { useState } from "react";
import { toast } from "react-toastify";
import { useContactGroups } from "../../../../context/ContactGroupsContext";

const GroupContactsModal = ({ isOpen, onClose, groupContacts, groupName, groupId, refreshGroupContacts,  refreshGroups }) => {
  const { removeContactsFromGroup } = useContactGroups();
  const [removingIds, setRemovingIds] = useState([]);

  if (!isOpen) return null;

  const handleRemove = async (contactId) => {
    try {
      setRemovingIds((prev) => [...prev, contactId]);
      await removeContactsFromGroup(groupId, [contactId]);

      toast.success("Contact removed from group");

      if (typeof refreshGroupContacts === "function") {
        await refreshGroupContacts(groupId);
      }
      if (typeof refreshGroups === "function") {
        await refreshGroups(); // ✅ refresh GroupsSection count
      }
    } catch (error) {
      toast.error("Failed to remove contact");
    } finally {
      setRemovingIds((prev) => prev.filter((id) => id !== contactId));
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-md w-full max-w-lg max-h-[80vh] overflow-y-auto">
        <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-white">
          Contacts in Group: {groupName}
        </h2>

        {groupContacts.length === 0 ? (
          <p className="text-gray-600 dark:text-gray-300">No contacts in this group.</p>
        ) : (
          <ul className="space-y-2">
            {groupContacts.map((contact) => (
              <li
                key={contact.id}
                className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 py-2 text-gray-800 dark:text-white"
              >
                <div>
                  {contact.name} — {contact.email || "No Email"}
                </div>
                <button
                  onClick={() => handleRemove(contact.id)}
                  disabled={removingIds.includes(contact.id)}
                  className="text-red-600 text-sm hover:text-red-800"
                >
                  {removingIds.includes(contact.id) ? "Removing..." : "Remove"}
                </button>
              </li>
            ))}
          </ul>
        )}

        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded hover:bg-gray-400"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupContactsModal;
